export default {
  'eosAccount': 'EOS Account',
  'disconnectWallet': 'Disconnect Wallet',
  'weUse': 'We use',
  'scatterInfoPhrase': 'to interact with the Stacks blockchain. That way you can easily receive your VIBES rewards. If you don’t know how to use Hiro Wallet or have a Stacks account, contact us using the blue chat widget.',
  'connectToScatter': 'Connect to Scatter',
  'connectTo': 'Connect to',
  'title': 'Wallet',
  'all': 'All',
  'txDate': 'Date',
  'txContractAction': 'Contract/Action',
  'txFrom': 'From',
  'txTo': 'Receiver',
  'txQty': 'Quantity',
  'txStatus': 'Status',
  'txStatusReceived': 'Received',
  'txStatusSent': 'Sent',
  'viewTransaction': 'View Transaction',
  'transferSucess': 'Transfer Successful!',
  'connectYourEOSAccount': 'Connect your EOS account',
  'connectedTo': 'Connected to',
  'stacksAccount': 'Stacks Account',
  'connectYourStacks': 'Connect your Stacks account',
  'connectedToHiro': 'Connected to Hiro Wallet',
  'disconnectWalletcap': 'DISCONNECT WALLET',
  'vibes': 'VIBES'
}



// WEBPACK FOOTER //
// ./src/i18n/en/wallet.js